export default "https://cdn-static-staging.gokick.com/assets/fcb4ac80126f26ea915890c2472f26527471791c/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";